import editorModel from '../data/editorModel';
const SITE_GENERATION_TEMPLATE_ID = 'd2edaaf7-274a-4f0b-9468-67313dac43cb';
export const isSiteGenerationTemplate = () => {
    const { originalTemplateId } = editorModel.siteHeader;
    return originalTemplateId === SITE_GENERATION_TEMPLATE_ID;
};
